import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AIAssistant from '../components/AIAssistant';

export default function Assistant() {
  const location = useLocation();
  const initialMessage = (location.state as { initialMessage?: string } | null)?.initialMessage;

  return (
    // Fill the available height from MainLayout's flex container.
    // Negative margins cancel MainLayout's py/px padding so the chat fills edge-to-edge.
    <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      mx: { xs: -2, sm: -3 },
      mt: { xs: -3, sm: -4 },
      mb: { xs: -3, sm: -4 },
    }}>
      <AIAssistant initialMessage={initialMessage} />
    </Box>
  );
}